import type { PendingQuantityWrite } from "./quantity-write-queue";
import "./quantity-write-status.css";

const labels = { PRODUCTION: "Üretim", WASTE: "Üretim kaybı", SCRAP: "Iskarta" };
export function PendingQuantityWrites({ items, storageError, canRetry, retry, verify, dismissRejected }: {
  items: PendingQuantityWrite[];
  storageError: string | null;
  canRetry: (item: PendingQuantityWrite) => boolean;
  retry: (id: string) => Promise<void>;
  verify: (id: string) => Promise<void>;
  dismissRejected: (id: string) => Promise<void>;
}) {
  if (!items.length && !storageError) return null;
  return <section className="operator-write-receipts" aria-label="Bekleyen kayıtlar">
    <p role="status">{storageError ?? `${items.length} kayıt sunucu onayı bekliyor. Bu cihazdaki miktarlar doğrulanmış toplama eklenmedi. Tarayıcı deposu sunucu kaydı değildir.`}</p>
    {items.map((item) => <article key={item.idempotencyKey}>
      <div><strong>{labels[item.draft.type]} · {item.draft.quantity} {item.draft.unit}</strong>
        <small>{item.workOrderNo} · {item.status === "SENDING" ? "Gönderiliyor…" : item.status === "UNSENT" ? "Cihazda bekliyor" : item.status === "UNCERTAIN" ? "Sunucu sonucu doğrulanamadı" : "Sunucu kaydı reddetti"}</small>
        {item.error ? <p>{item.error}</p> : null}
      </div>
      {item.status !== "SENDING" ? <div className="operator-write-actions">
        <button type="button" disabled={!canRetry(item)} onClick={() => void retry(item.idempotencyKey)}>{item.status === "UNSENT" ? "Gönder" : "Aynı kaydı yeniden dene"}</button>
        {item.status !== "UNSENT" ? <button type="button" onClick={() => void verify(item.idempotencyKey)}>Sunucuda kontrol et</button> : null}
        {item.status === "FAILED" ? <button type="button" onClick={() => void dismissRejected(item.idempotencyKey)}>Vazgeç</button> : null}
        {!canRetry(item) ? <small>Bağlantı ve kaydı açan operatör oturumu doğrulanmalı.</small> : null}
      </div> : null}
    </article>)}
  </section>;
}
